import { React } from "react";

import MoreLinks from "../dashboard.leftbar.component/leftbar.moreLinks.component";
export const Footer = ({ Show, setShow, setPopStyle }) => {
  // let history = useHistory();
  // const Path = history.location.pathname
  return (
    <>
      <MoreLinks />

      {/* {
      Path.toLowerCase() == '/dashboard' && <div className="navFooter">

        <div className='CTAButton'
          style={{
            position: 'relative',
            top: '60%',
            left: '0px',
            fontSize:'12px'
          }}
          onClick={(e) => {
            setShow(!Show)
            let data = e.target.getBoundingClientRect();
            setPopStyle({ top: data.top - 85 });
          }}
        >
          Account
        </div>

      </div>
    } */}
    </>
  );
};

export default Footer;
